const _ = require('lodash');

class ResetPasswordController {
    constructor($q, resetPasswordService) {
        this.$q = $q;
        this.resetPasswordService = resetPasswordService;

        this.showForm = false;
        this.tokenInvalid = false;
        this.loading = false;

        this.validatePasswordReminderToken();
    }

    validatePasswordReminderToken() {
        this.resetPasswordService.validatePasswordReminderToken(this.passwordResetToken).then((response) => {
            this.tokenInvalid = !response.Success;
        }).catch(() => {
            this.tokenInvalid = true;
        }).finally(() => {
            this.showForm = true;
        });
    }

    submit() {

        if (!this.resetPasswordForm.$valid) {
            // don't submit to server if client side is not valid
            return this.$q.reject();
        }

        this.loading = true;
        return this.resetPasswordService.resetPassword(this.resetPassword.password, this.resetPassword.passwordConfirm, this.passwordResetToken).then((response) => {
            if (response.Success) {
                window.location.href = '/';
            }
        }).catch((repsonse) => {
            this.resetErrors();
            _.forEach(repsonse.data.ResponseStatus.Errors, (n) => {
                if (n.FieldName === 'ReminderToken') {
                    this.tokenInvalid = true;
                } else {
                    if (this.resetPasswordForm[n.FieldName]) {
                        this.resetPasswordForm[n.FieldName].$setValidity('serverError', false);
                    }
                    this.serverErrors[n.FieldName] = n.Message;
                }
            });
        }).finally(() => {
            this.loading = false;
        });
    }

    resetErrors() {
        this.resetPasswordForm.NewPassword.$setValidity('serverError', true);
        this.resetPasswordForm.NewPasswordConfirmation.$setValidity('serverError', true);
        this.serverErrors = {};
    }

}

const resetPasswordComponentDefinition = {
    bindings: {
        passwordResetToken: '@',
    },
    controller: ['$q', 'ResetPasswordService', ResetPasswordController],
    template: require('./reset-password.component.html').trim(),
};

module.exports = {
    ResetPasswordController,
    resetPasswordComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/resetpassword/reset-password.component.js